// flow weak

import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import styles                 from './style'
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import {Link} from 'react-router-dom';
import { withRouter } from 'react-router';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import Avatar from 'material-ui/Avatar';


class EditStats extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      id: props.match.params.id,
      result: '',
      games: '',
      stats: {},
     
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    
  }

  
  componentDidMount() {
    this.getStatsList();
  }

  getStatsList() {
     const url = `${getLocationOrigin()}/fixture_session/${this.state.id}/detail_load/`;
     const options = {...defaultOptions};

     fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({ result: data, games: data.games, metrics: data.other_metrics }))
       .catch(error => error);
  }

  editStats(value, props) {
    const url = `${getLocationOrigin()}/fixture_session/${this.state.id}/set_game_player_metric/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({'customer_id': value,
                                        'stats': this.state.stats});
    console.log('Going to fetch');
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then(function(response){                      // first then()
          alert(response.Message);
          props.history.goBack();
      })
      .catch(error => {
        console.log(error);
        alert(error.message);
      });
  }
handleSubmit(event) {
    event.preventDefault();
  }
  handleChange(event){
    const name = event.target.name;
    var new_selected_one = Object.assign({}, this.state.stats);
    new_selected_one[name] = event.target.value
    this.setState({stats: new_selected_one})
  }
  
  render() {
    console.log(this.state.id);
    console.log(this.props);
    return(
      <div style={styles.container}>
        <div className="row col-md-12 table-bordered" style={styles.table}>
          <div style={styles.main_header} className="col-md-12">
            <h3 style={{textAlign:'center', color: '#FFFFFF'}}>Edit Stats</h3>
          </div>
          <form  className="validated-form form-horizontal" onSubmit={this.handleSubmit}>
            <div style={styles.items} className="col-md-12">
              <div className="col-md-12">
                {
                  (this.state.games) ?
                    this.state.games.map((game, index)=>(
                      <div key={game.id}>
                      {
                        game.teams.map((team, index)=>(
                          <div key={index} className="col-md-12" style={{backgroundColor: '#FFFFFF', padding: '1%'}}>
                          <span style={{color: "#000000", marginLeft: '47%', fontSize: '120%',fontWeight: 600, marginBottom: '2%'}}>{team.name}</span>
                            <div className="col-md-12" style={{flexDirection: 'row', justifyContent: 'space-between'}}>
                            {
                              team.customers.map((cust, index)=>(
                                <div key={cust.id} className="col-md-12 table-bordered" style={{padding: '1%',  backgroundColor: '#39435C',}}> 
                                <div className="col-md-3">                              
                                <Avatar size={50} src={ `https://api.sporthood.in/${cust.photo}`  } />
                                <span style={{color: "#FFFFFF", padding: '1%', marginLeft: '1%', fontSize: '100%',fontWeight: '600'}}>{cust.name}</span>
                                </div>
                                <div className="col-md-9" style={{marginTop: '1.5%'}}>
                                {
                                  Object.keys(cust.stats).map((key, index)=>(
                                    <div key={index} className="col-md-2" style={{flexDirection: 'row', justifyContent: 'space-between'}}>
                                    <span style={{color: "#FFFFFF", padding: '1%', fontSize: '80%',fontWeight: '600'}}>{key + " : "}</span>
                                    <input type="text" style={styles.input} name={key} className="required" 
                                     onChange={this.handleChange} placeholder={cust.stats[key]}/>

                                    </div>
                                    ))
                                }
                                <div className="col-md-2">
                                   <button className="btn btn-default" style={{backgroundColor: '#FDD60B', padding: '5%', borderColor: '#FDD60B', borderWidth: '2px', width: '100px'}}
                                    type="button" onClick={()=>this.editStats(cust.id, this.props)}><span style={{color: '#000000'}}>Save</span></button>
                                  </div>
                                </div>
                                
                                </div>))
                            }
                            </div>
                          </div>
                          ))
                      }
                      
                      </div>

                      ))
                    :
                    <div style={{marginLeft: '47%'}}>
                      <span style={{color: "#000000", textAlign: 'center', justifyContent: 'center'}}>Loading...</span>
                    </div>
                }
              </div>
           </div>
          </form>
        </div>
      </div>
    );
  }
}

export default EditStats;



// WEBPACK FOOTER //
// ./src/app/views/partner/crud/editStats/index.js